export default __webpack_public_path__ + "static/media/colored-offer-publish-icon.7c86b912.svg";